import { isArray, keys, toString } from '../shortcut'

export function isEmpty(value: any): boolean {
  const type = typeof value
  if (type === 'undefined' || value === null) return true
  if (type === 'boolean' || type === 'function') return false
  if (type === 'number' || type === 'bigint') return false
  if (type === 'string') return value.length === 0
  if (isArray(value)) return value.every(isEmpty)
  if (toString.call(value) === '[object Object]')
    return keys(value).length === 0
  if ('size' in value) return value.size === 0
  if ('length' in value) return value.length === 0
  return false
}

export function isNotEmpty(value: any): boolean {
  const type = typeof value
  if (type === 'undefined' || value === null) return false
  if (type === 'boolean' || type === 'function') return true
  if (type === 'number' || type === 'bigint') return true
  if (type === 'string') return value.length > 0
  if (isArray(value)) return value.length > 0 && value.every(isNotEmpty)
  if (toString.call(value) === '[object Object]') return keys(value).length > 0
  if ('size' in value) return value.size > 0
  if ('length' in value) return value.length > 0
  return true
}
